import { render, staticRenderFns } from "./SocialMediaForm.vue?vue&type=template&id=4e0bf131&scoped=true"
import script from "./SocialMediaForm.vue?vue&type=script&lang=ts"
export * from "./SocialMediaForm.vue?vue&type=script&lang=ts"
import style0 from "./SocialMediaForm.vue?vue&type=style&index=0&id=4e0bf131&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0bf131",
  null
  
)

export default component.exports